import React from 'react';
import { Link } from 'react-router-dom';
import { useSavedJobs } from '../context/SavedJobsContext';
import { Briefcase, MapPin, DollarSign } from 'lucide-react';

export default function SavedJobs(){
  const { saved, removeJob } = useSavedJobs();

  return (
    <div className="bg-background-offwhite min-h-screen py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Saved Vacancies</h1>

        {saved.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-12 text-center">
            <Briefcase className="mx-auto text-gray-300 mb-4" size={48} />
            <p className="text-gray-600">You have no saved vacancies yet. Browse vacancies and save the ones you like.</p>
            <Link to="/jobs" className="mt-6 inline-block bg-primary-medium text-white px-4 py-2 rounded">Browse Vacancies</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {saved.map(job => (
              <div key={job.id} className="bg-white rounded-lg shadow p-6 flex items-start gap-4">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500 font-bold">{job.employer_name?.split(' ').map(n=>n[0]).slice(0,2).join('')}</div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-1">{job.title}</h3>
                  <p className="text-gray-600 mb-2">{job.employer_name} • {job.location}</p>
                  <div className="flex items-center gap-3 text-sm text-gray-600">
                    {job.salary_min && <div className="flex items-center gap-1"><DollarSign size={14}/> ${job.salary_min}-${job.salary_max}</div>}
                    <div className="flex items-center gap-1"><MapPin size={14}/> {job.location}</div>
                  </div>
                </div>
                <div className="text-right">
                  <Link to={`/jobs/${job.id}`} className="block mb-2 text-sm text-primary-deep font-semibold">View</Link>
                  <button onClick={() => removeJob(job.id)} className="text-sm text-red-600">Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
